import { Popover, PopoverContent, PopoverTrigger } from 'components/UI/popover'
import { useTableLinkVariant } from './TableLinkStyleContext'

/**
 * White "+N" overflow chip. Click opens a centered popover listing the hidden
 * pills (or any provided children) in a scrollable container. Used by Campaigns,
 * Tags, and Contact Labels cells in place of the old `<span>+N</span>` text.
 *
 * Outside the DS2026 surface (TableLinkStyleProvider variant="plain") it falls
 * back to the original plain "+N" text so other tables stay unchanged.
 */
export function PillOverflowChip({
  count,
  children,
}: {
  count: number
  children: React.ReactNode
}) {
  const variant = useTableLinkVariant()
  if (count <= 0) return null

  if (variant !== 'plain') {
    return <span>+{count}</span>
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-scroll-list-trigger
          className="inline-flex items-center rounded-2xl bg-white px-2.5 py-0.5 text-sm font-medium leading-5 text-neutral-700 ring-1 ring-inset ring-neutral-200 hover:bg-neutral-50"
          style={{ letterSpacing: '-0.2px' }}
        >
          +{count}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="center"
        sideOffset={-32}
        className="max-h-80 w-64 overflow-y-auto !p-3"
      >
        <div className="flex flex-wrap gap-1">{children}</div>
      </PopoverContent>
    </Popover>
  )
}
